import {reactive} from "vue";

export interface EnumOption {
    label: string;
    value: string;
}

export async function spellEnum (enumName: string): Promise<string[]> {
    var res = await fetch('/api/public/enums/' + enumName, {
        method: 'GET',
        credentials: 'include'
    })
    if (!res.ok) {
        throw new Error(`Request failed with status ${res.status}`)
    }
    const data = await res.json()
    return data
}

export async function getEnumWithLabels (enumName: string): Promise<EnumOption[]> {
    var res = await fetch('/api/public/enums/labels/' + enumName, {
        method: 'GET',
        credentials: 'include'
    })
    if (!res.ok) {
        throw new Error(`Request failed with status ${res.status}`)
    }
    const data = await res.json()
    return data
}

export class GlobalEnums {
    MensOrganisatieRelaties: EnumOption[];
    Disciplines: string[];
    SoortDocument: string[];
    ActorAard: string[];
    MimeTypes: EnumOption[];
    Informatie: string[];      // bewijs van
    Typologie: string[];
    IdProviders: string[];
    Agendae: string[];


    constructor() {
    }


    async setup() {
        this.MensOrganisatieRelaties = await getEnumWithLabels("com.inicon.actoren.enums.Relatie");
        this.Disciplines = await spellEnum("com.inicon.domein.Discipline");
        this.SoortDocument = await spellEnum("com.inicon.documenten.SoortDocument");
        this.ActorAard = await spellEnum("com.inicon.actoren.enums.ActorAard");
        this.MimeTypes = await getEnumWithLabels("com.inicon.documenten.MimeType");
        this.Informatie = await spellEnum("com.inicon.documenten.Informatie");
        this.Typologie = await spellEnum("com.inicon.zaken.Typologie");
        this.IdProviders = await spellEnum("com.inicon.config.AuthenticationProvider");
        this.Agendae = await spellEnum("com.inicon.agenda.AgendaServiceProvider");
    }

    isReady() : boolean {
        return this.MensOrganisatieRelaties != undefined && this.Disciplines != undefined && this.Typologie != undefined && this.IdProviders != undefined
            && this.Agendae != undefined && this.Agendae != undefined && this.ActorAard != undefined && this.MimeTypes != undefined
            && this.Informatie != undefined;
    }

}

export const globalEnums = reactive(new GlobalEnums());
